import React from "react";
import { Trans } from "react-i18next";

import { LinearProgress, Typography, styled } from "@mui/material";
import { Paper } from "@mui/material";

import StyledPaper from "../styled/Paper";

const LoadingBox = styled(StyledPaper)(
    ({ theme }) => ({
        position: 'absolute',
        //top: '50%',
        //left: '50%',
        width: '50%',
        padding: theme.spacing(3),
        transform: 'translate(-50%, -50%)',
        backgroundColor: localStorage.getItem('currentTheme') !== 'Dark' ? '#FFFFFF' : '#1E2433',
        color: localStorage.getItem('currentTheme') !== 'Dark' ? '#000000' : '#FFFFFF'
    }),
);

export const LoadingScreen = ({ text = 'Loading', noProgress = false, value = null, variant = 'indeterminate', display = true, top = '50%', left = '50%' }) => {
    return (
        <LoadingBox style={{display: ! display ? 'none' : 'block', top: top, left: left}}>
            <Typography align="center" variant="subtitle1">
                <Trans>{text}</Trans>
                {!noProgress && '...'}
            </Typography>
            {!noProgress && <LinearProgress color="primary" sx={{ mt: 2 }} value={value} variant={variant} />}
        </LoadingBox>
    );
};

export const CustomLoadingScreen = ({ text = 'Loading', noProgress = false, value = null, variant = 'indeterminate', style}) => {
    return (
        <Paper style={style}>
            <Typography align="center" variant="subtitle1">
                <Trans>{text}</Trans>
                {!noProgress}
            </Typography>
            {!noProgress && <LinearProgress color="primary" sx={{ mt: 2 }} value={value} variant={variant} />}
        </Paper>
    );
}